import {createSelector} from '@ngrx/store';
import {identity} from 'rxjs';
import {AppState} from '../../interfaces/app-state.interface';

export class BelegFilterTableSelectors {
  private static select = {
    tableSettings: (state: AppState) => state.belegFilterTableReducer?.tableSettings,
  };

  public static tableSettings = createSelector(this.select.tableSettings, identity);
}
